<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<section class="package_search_bar"></section>
<section class="package_container container-fluid">
  <div class="row_title mar-top-30 no-mar-lr" *ngIf="userRoleID == 1 || userRoleID == 2 ||userRoleID == 3 ||userRoleID == 7">{{'Supplier Package Code' | translate}}</div>
  <div class="row_title no-mar-lr mar-top-30" *ngIf="(userRoleID == 5 || userRoleID == 9) && !adminFuso">{{'Edit Supplier Package Code' | translate}}</div>
  <div class="row_title no-mar-lr mar-top-30" *ngIf="(userRoleID == 5 || userRoleID == 9) && adminFuso">{{'Edit Fuso Package Code' | translate}}</div>
  <!-- <div class="row_title mar-top-30" *ngIf="userRoleID == 5 || userRoleID == 9" [text]="adminFuso ? 'Select to edit Fuso Package Code': 'jdhsfksf'"></div> -->
  <button type="button" class="btn btn-dark mar-top-50" *ngIf="userRoleID == 1 || userRoleID == 2 ||userRoleID == 3 ||userRoleID == 7"
    (click)="showNewList()">{{'List of Supplier Package Code' | translate}}</button>
  <div class="row padding-bottom">
    <div class="col-md-12">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-white table-striped table-bordered "
        *ngIf="(userRoleID == 1 || userRoleID == 2 ||userRoleID == 3 ||userRoleID == 7)">
        <thead>
          <tr>
            <th class="text-center">{{'PKGCODE' | translate}}</th>
            <th class="text-center">{{'PKGNAME' | translate}}</th>
            <th class="text-center">{{'CREATEDATE' | translate}}</th>
            <th class="text-center" *ngIf="userRoleID == 3">{{'Supplier Name' | translate}}</th>
            <th class="text-center" *ngIf="userRoleID == 3">{{'SUPPLIERCODE' | translate}}</th>
            <th class="text-center">{{'CURRENTSTATUS' | translate}}</th>
            <th class="text-center">{{'COMMENTS' | translate}}</th>
            <th class="text-center" *ngIf="userRoleID == 1">{{'LOGISTICOMMENTS' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of packages" class="even">
            <td class="text-center partno_column hasLink">
              <a (click)="openPkgRequested(pkgRequested, item.packageCode)">{{ item.packageCode }}</a>
            </td>
            <td class="text-center">{{ item.packagingName }}</td>
            <td class="text-center">{{ item.updatedDate | date:'yyyy-MM-dd' }}</td>
            <td class="text-center" *ngIf="userRoleID == 3">{{ item.createBy }}</td>
            <td class="text-center" *ngIf="userRoleID == 3">{{ item.supplierCode }}</td>
            <td class="status_review text-center" [ngStyle]="{'color':item.packageCodeStatus === 'rejected' ? 'red' : 'green' }">{{
              item.packageCodeStatus | titlecase}}</td>
            <td class="text-center cell-ellipse" pTooltip="{{item.supplierComment}}" tooltipPosition="top">{{
              item.supplierComment }}</td>
            <td class="text-center cell-ellipse" *ngIf="userRoleID == 1 && item.logisticsComment != null" pTooltip="{{item.logisticsComment}}"
              tooltipPosition="top">{{item.logisticsComment}}</td>
            <td class="text-center" *ngIf="userRoleID == 1 && item.logisticsComment == null">--</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
<!-- <div class="table-bottom"></div> -->
<!-- <section class="package_search_bar1 mar-top" *ngIf="userRoleID == 3 || userRoleID == 2 ||userRoleID == 7"></section>
<section class="package_search_bar1" *ngIf="userRoleID != 1 || userRoleID != 3"></section> -->
<section class="package_search_bar1 mar-top" *ngIf="userRoleID == 2 ||userRoleID == 7"></section>
<section class="package_container container-fluid mar-btm-50">
  <div class="row_title no-mar-lr" *ngIf="userRoleID == 2 || userRoleID == 3 || userRoleID == 4 || userRoleID == 7">{{'Fuso Package Code' | translate}}</div>
  <button type="button" class="btn btn-dark mar-top-30" *ngIf="userRoleID == 2 || userRoleID == 3 || userRoleID == 4 || userRoleID == 7"
    (click)="showFusoList()">{{'List of Fuso Package Code' | translate}}</button>
  <div class="row">
    <div class="col-md-12">
      <table datatable *ngIf="userRoleID == 2 || userRoleID == 3 || userRoleID == 4 || userRoleID == 7" [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger" class="table table-white table-bordered table-striped">
        <thead>
          <tr>
            <th class="text-center">{{'Fuso Package Code' | translate}}</th>
            <th class="text-center">{{'Fuso Package Name' | translate}}</th>
            <th class="text-center">{{'CREATEDATE' | translate}}</th>
            <th class="text-center">{{'CURRENTSTATUS' | translate}}</th>
            <th class="text-center">{{'COMMENTS' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of fusoPackages">
            <td class="text-center partno_column hasLink">
              <a (click)="openFusoPkgRequested(fusoPkgRequested, item.fusoPackageCode)">{{ item.fusoPackageCode }}</a>
            </td>
            <td class="text-center">{{ item.packagingName }}</td>
            <td class="text-center">{{ item.updatedDate | date:'yyyy-MM-dd' }}</td>
            <td class="status_review text-center">{{ item.newPackageCodeStatus | titlecase}}</td>
            <td class="text-center cell-ellipse"><span pTooltip="{{item.comment}}" tooltipPosition="top" [appendTo]="container">{{
                item.comment }}</span> </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
<!-- Admin Table for Packages-->
<section *ngIf="userRoleID == 5 || userRoleID == 9">
  <div class="container-fluid" *ngIf="!adminFuso">
    <div class="ui-widget-header" style="padding:4px 10px;border-bottom: 0 none">
      <!-- <i class="fa fa-search" style="margin:4px 4px 0 250px"></i>
      <input #gb type="text" styleClass="Search" pInputText size="80" style="margin:20px; padding:6px;border: 1px solid #ced4da;border-radius: 0.25rem;"
        placeholder="{{'Search your value' | translate}}"> -->
    </div>
    <p-table #dt1 [value]="allPackages" [globalFilterFields]="['packageCode','packagingName','createBy','createdDate','updatedBy','updatedDate','supplierCode','supplierComment']" [responsive]="true" [rows]="10" [paginator]="true"
    selectionMode="single" (onRowSelect)="rowEdit(editDetails, $event.data)" [pageLinks]="3" [rowsPerPageOptions]="[10,25,50,100]"
    [style]="{'margin-bottom': '50px'}">
    <ng-template pTemplate="caption">
      <div class="flex">
          <span class="p-input-icon-left ml-auto">
            <i class="fa fa-search" style="margin-left: 140px;" ></i>
    
              <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Search your value" />
          </span>
      </div>
  </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="packageCode" style="width:20px" *ngIf="userRoleID != 1" [hidden]="userRoleID == 3 && openRequested == true"
        >{{'PKGCODE' | translate}}<p-sortIcon field="packageCode"></p-sortIcon></th>
        <th pSortableColumn="packagingName" style="width:20%">{{'PKGNAME' | translate}}<p-sortIcon field="packagingName"></p-sortIcon></th>
        <th pSortableColumn="createBy" style="width:20%">{{'Created By' | translate}}<p-sortIcon field="createBy"></p-sortIcon></th>
        <th pSortableColumn="createdDate" style="width:20%">{{'CREATEDATE' | translate}}<p-sortIcon field="createdDate"></p-sortIcon></th>
        <th pSortableColumn="updatedBy" style="width:20%">{{'UPDATEDBY' | translate}}<p-sortIcon field="updatedBy"></p-sortIcon></th>
        <th pSortableColumn="updatedDate" style="width:20%">{{'UPDATEDATE' | translate}}<p-sortIcon field="updatedDate"></p-sortIcon></th>
        <th pSortableColumn="packageCodeStatus" style="width:20%">{{'STATUS' | translate}}<p-sortIcon field="packageCodeStatus"></p-sortIcon></th>
        <th pSortableColumn="supplierCode" style="width:20%">{{'SUPPLIERCODE' | translate}}<p-sortIcon field="supplierCode"></p-sortIcon></th>
        <th pSortableColumn="supplierComment" style="width:20%">{{'COMMENTS' | translate}}<p-sortIcon field="supplierComment"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr (click)="rowEdit(editDetails, value)">
          <td style="width:20px">{{value.packageCode}}</td>
          <td>{{value.packagingName}}</td>
          <td>{{value.createBy}}</td>
          <td>{{value.createdDate | date:'mediumDate'}}</td>
          <td>{{ value.updatedBy}}</td>
          <td> {{value.updatedDate | date:'mediumDate'}}</td>
          <td> <span [ngStyle]="{'color': value.packageCodeStatus === 'Approved' ? 'red' : 'green' }">{{value.packageCodeStatus | titlecase}}</span></td>
          <td> {{ value.supplierCode }}</td>
          <td>{{ value.supplierComment }}</td>
      </tr>
    </ng-template>
    </p-table>
    <!-- <p-dataTable [value]="allPackages" [globalFilter]="gb" [responsive]="true" [rows]="10" [paginator]="true"
      selectionMode="single" (onRowSelect)="rowEdit(editDetails, $event.data)" [pageLinks]="3" [rowsPerPageOptions]="[10,25,50,100]"
      [style]="{'margin-bottom': '50px'}">
      <p-column class="text-center" field="packageCode" header="{{'PKGCODE' | translate}}" [sortable]="true"></p-column>
      <p-column class="text-center" field="packagingName" header="{{'PKGNAME' | translate}}" [sortable]="true"></p-column>
      <p-column class="text-center" field="createBy" header="{{'Created By' | translate}}" [sortable]="true"></p-column>
      <p-column class="text-center" field="createdDate" header="{{'CREATEDATE' | translate}}" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
          {{row.createdDate | date:'mediumDate'}}
        </ng-template>
      </p-column>
      <p-column class="text-center" field="updatedBy" header="{{'UPDATEDBY' | translate}}" [sortable]="true"></p-column>
      <p-column class="text-center" field="updatedDate" header="{{'UPDATEDATE' | translate}}" [sortable]="true">
        <ng-template let-row="rowData" pTemplate="body">
          {{row.updatedDate | date:'mediumDate'}}
        </ng-template>
      </p-column>
      <p-column class="text-center" field="packageCodeStatus" header="{{'STATUS' | translate}}" [sortable]="true"
        [style]="{'font-weight': 'bold'}">
        <ng-template let-row="rowData" pTemplate="body">
          <span [ngStyle]="{'color':row.packageCodeStatus === 'Approved' ? 'red' : 'green' }"> {{row.packageCodeStatus
            | titlecase}}</span>
        </ng-template>
      </p-column>
      <p-column class="text-center" field="supplierCode" header="{{'SUPPLIERCODE' | translate}}" [sortable]="true"></p-column>
      <p-column class="text-center" field="supplierComment" header="{{'COMMENTS' | translate}}" [sortable]="true"></p-column>
    </p-dataTable> -->
  </div>
  <div *ngIf="adminFuso">
    <div class="container-fluid">
      <div class="ui-widget-header" style="padding:4px 10px;border-bottom: 0 none">
        <i class="fa fa-search" style="margin:4px 4px 0 250px"></i>
        <input #gb type="text" styleClass="Search" pInputText size="80" style="margin:20px; padding:6px;border: 1px solid #ced4da;border-radius: 0.25rem;"
          placeholder="{{'Search your value' | translate}}">
      </div>
      <p-table   [value]="fusoLookupList" [globalFilterFields]="['fusoPackageCode','packagingName','createBy','createdDate','updatedBy','updatedDate','newPackageCodeStatus','comment']" [responsive]="true" [rows]="10" [paginator]="true"
      selectionMode="single" (onRowSelect)="rowEditFuso(editFusoDetails, $event.data)" [pageLinks]="3"
      [rowsPerPageOptions]="[10,25,50,100]" [style]="{'margin-bottom': '50px'}">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="fusoPackageCode" style="width:20%" *ngIf="userRoleID != 1" [hidden]="userRoleID == 3 && openRequested == true"
            >{{'Fuso Package Code' | translate}}<p-sortIcon field="fusoPackageCode"></p-sortIcon></th>
            <th pSortableColumn="packagingName" style="width:20%">{{'Fuso Package Name' | translate}}<p-sortIcon field="packagingName"></p-sortIcon></th>
            <th pSortableColumn="createBy" style="width:20%">{{'Created By' | translate}}<p-sortIcon field="createBy"></p-sortIcon></th>
            <th pSortableColumn="createdDate" style="width:20%">{{'CREATEDATE' | translate}}<p-sortIcon field="createdDate"></p-sortIcon></th>
            <th pSortableColumn="updatedBy" style="width:20%">{{'UPDATEDBY' | translate}}<p-sortIcon field="updatedBy"></p-sortIcon></th>
            <th pSortableColumn="updatedDate" style="width:20%">{{'UPDATEDATE' | translate}}<p-sortIcon field="updatedDate"></p-sortIcon></th>
            <th pSortableColumn="newPackageCodeStatus" style="width:20%">{{'STATUS' | translate}}<p-sortIcon field="newPackageCodeStatus"></p-sortIcon></th>
            <th pSortableColumn="comment" style="width:20%">{{'COMMENTS' | translate}}<p-sortIcon field="comment"></p-sortIcon></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-value>
          <tr (click)="rowEditFuso(editFusoDetails, value)">
              <td>{{value.fusoPackageCode}}</td>
              <td>{{value.packagingName}}</td>
              <td>{{value.createBy}}</td>
              <td>{{value.createdDate | date:'mediumDate'}}</td>
              <td>{{ value.updatedBy}}</td>
              <td> {{value.updatedDate | date:'mediumDate'}}</td>
              <td> <span [ngStyle]="{'color':value.newPackageCodeStatus === 'Approved' ? 'red' : 'green' }">{{value.newPackageCodeStatus
                | titlecase}}</span></td>
              <td>{{ value.comment}}</td>
          </tr>
        </ng-template>
      </p-table>
     
    </div>
  </div>
</section>

<ng-template #pkgRequested let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'New Package Requested' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-new-package [openRequested]="openRequested" [pkgIdCreated]="pkgIdCreated" (closeModalPopup)="closeModal($event)"></app-new-package>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
  </div>
</ng-template>

<ng-template #fusoPkgRequested let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'New Package Requested' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-new-package [openfusoRequested]="openfusoRequested" [fusoPkgIdCreated]="fusoPkgIdCreated" (createFuso)="createdFuso($event)"></app-new-package>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
  </div>
</ng-template>

<ng-template #editDetails let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'Edit Package Code' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-new-package [pkgData]="pkgData" [adminEdit]="adminEdit" (closeAdmitEdit)="closeAdmitEdit($event)"></app-new-package>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
  </div>
</ng-template>

<ng-template #editFusoDetails let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{'Edit Supplier Package Code' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-new-package [pkgFusoData]="pkgFusoData" [admitFusoEdit]="admitFusoEdit" (closeAdminFusoEdit)="closeAdminFusoEdit($event)"></app-new-package>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
  </div>
</ng-template>

<p-dialog id="fusoDashList" header="{{'Supplier Package Code' | translate}}" [(visible)]="displayNew" [responsive]="true"
  showEffect="fade" [modal]="true" [closable]="true" [style]="{width: '800'}">
  <button type="button" (click)="dt.exportCSV()">Export as CSV</button>
  <div class="codeList mar-top-20">
    <p-table #dt [value]="NewLookupList" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
      [rowsPerPageOptions]="[10,25,50,100]">
      <!-- <p-column field="packageCode" header="{{'PKGCODE' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search  {{'PKGCODE' | translate}}"></p-column>
      <p-column field="externalPackDimL" header="{{'LENGTH' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'LENGTH'  | translate}}"></p-column>
      <p-column field="externalPackDimW" header="{{'WIDTH' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'WIDTH'  | translate}}"></p-column>
      <p-column field="externalPackDimH" header="{{'HEIGHT' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'HEIGHT'  | translate}}"></p-column>
      <p-column field="totalMaxWeightBox" header="{{'WEIGHT' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'WEIGHT'  | translate}}"></p-column> -->
        <ng-template pTemplate="header">
          <tr>
              <th pSortableColumn="packageCode" style="width:20%">{{'PKGCODE' | translate}} <p-sortIcon field="packageCode"></p-sortIcon></th>
              <th pSortableColumn="externalPackDimL" style="width:20%">{{'LENGTH' | translate}} <p-sortIcon field="externalPackDimL"></p-sortIcon></th>
              <th pSortableColumn="externalPackDimW" style="width:20%">{{'WIDTH' | translate}}<p-sortIcon field="externalPackDimW"></p-sortIcon></th>
              <th pSortableColumn="externalPackDimH" style="width:20%">{{'HEIGHT' | translate}} <p-sortIcon field="externalPackDimH"></p-sortIcon></th>
              <th pSortableColumn="totalMaxWeightBox" style="width:20%">{{'WEIGHT' | translate}} <p-sortIcon field="totalMaxWeightBox"></p-sortIcon></th>
          </tr>
          <tr>
            <th>
              <p-columnFilter type="text" field="packageCode"></p-columnFilter>
          </th>
          <th>
            <p-columnFilter type="text" field="externalPackDimL"></p-columnFilter>
           </th>
           <th>
          <p-columnFilter type="text" field="externalPackDimW"></p-columnFilter>
          </th>
          <th>
             <p-columnFilter type="text" field="externalPackDimH"></p-columnFilter>
           </th>
          <th>
              <p-columnFilter type="text" field="totalMaxWeightBox"></p-columnFilter>
         </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-value>
          <tr>
              <td>{{value.packageCode}}</td>
              <td>{{value.externalPackDimL}}</td>
              <td>{{value.externalPackDimW}}</td>
              <td>{{value.externalPackDimH}}</td>
              <td>{{value.totalMaxWeightBox}}</td>
          </tr>
      </ng-template>
  
    </p-table>
  </div>

  <p-footer>
    <button type="button" pButton class="btn-dark-brd" (click)="displayNew = false" label="{{'Close' | translate}}"></button>
  </p-footer>
</p-dialog>

<p-dialog id="fusoDashList" header="{{'Fuso Package Code' | translate}}" [(visible)]="displayFuso" [responsive]="true"
  showEffect="fade" [modal]="true" [closable]="true" [style]="{width: '800'}">
  <!-- <button type="button" (click)="ft.exportCSV()">Export as CSV</button> -->

  <div class="codeList mar-top-20">
    <!-- <p-dataTable #ft [value]="fusoLookupList" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
      [rowsPerPageOptions]="[10,25,50,100]">
      <p-column field="fusoPackageCode" header="{{'PKGCODE' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search  {{'PKGCODE' | translate}}"></p-column>
      <p-column field="externalPackDimL" header="{{'LENGTH' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'LENGTH'  | translate}}"></p-column>
      <p-column field="externalPackDimW" header="{{'WIDTH' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'WIDTH'  | translate}}"></p-column>
      <p-column field="externalPackDimH" header="{{'HEIGHT' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'HEIGHT'  | translate}}"></p-column>
      <p-column field="totalMaxWeightBox" header="{{'WEIGHT' | translate}}" [sortable]="true" [filter]="true"
        filterPlaceholder="Search {{'WEIGHT'  | translate}}"></p-column>
    </p-dataTable> -->
    <p-table #ft [value]="fusoLookupList" [responsive]="true" [rows]="10" [paginator]="true" [pageLinks]="3"
    [rowsPerPageOptions]="[10,25,50,100]">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="fusoPackageCode" style="width:20%">{{'PKGCODE' | translate}}<p-sortIcon field="fusoPackageCode"></p-sortIcon></th>
        <th pSortableColumn="externalPackDimL" style="width:20%">{{'LENGTH' | translate}}<p-sortIcon field="externalPackDimL"></p-sortIcon></th>
        <th pSortableColumn="externalPackDimW" style="width:20%">{{'WIDTH' | translate}}<p-sortIcon field="externalPackDimW"></p-sortIcon></th>
        <th pSortableColumn="externalPackDimH" style="width:20%">{{'HEIGHT' | translate}}<p-sortIcon field="externalPackDimH"></p-sortIcon></th>
        <th pSortableColumn="totalMaxWeightBox" style="width:20%">{{'WEIGHT' | translate}}<p-sortIcon field="totalMaxWeightBox"></p-sortIcon></th>
      </tr>
      <tr>
        <th>
          <p-columnFilter  type="text" field="fusoPackageCode"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="externalPackDimL"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="externalPackDimW"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="externalPackDimH"></p-columnFilter>
        </th>
        <th>
          <p-columnFilter type="text" field="totalMaxWeightBox"></p-columnFilter>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
          <td>{{value.fusoPackageCode}}</td>
          <td>{{value.externalPackDimL}}</td>
          <td>{{value.externalPackDimW}}</td>
          <td>{{value.externalPackDimH}}</td>
          <td>{{value.totalMaxWeightBox}}</td>
      </tr>
    </ng-template>
    </p-table>
  </div>

  <p-footer>
    <button type="button" pButton class="btn-dark-brd" (click)="displayFuso = false" label="{{'Close' | translate}}"></button>
  </p-footer>
</p-dialog>